import {
  DockviewApi,
  DockviewDefaultTab,
  DockviewGroupPanelApi,
  DockviewPanelApi,
  DockviewReact,
  DockviewReadyEvent,
  IDockviewHeaderActionsProps,
  IDockviewPanelHeaderProps,
  IDockviewPanelProps,
} from "dockview";
import Main from "../Main";
import OptionsDefinitions from "../OptionsDefinitions";
import OptPricingModel from "../OptPricingModel";
import OptionSolver from "../OptionSolver";
import EquityChart from "../EquityChart";
import KK7766comments from "../KK7766comments";
import { NewsSearch } from "../NewsSearch";
import { TweetsSearch } from "../TweetsSearch";
import { Correlate } from "../Correlate";
import { RedditSearch } from "../RedditSearch";
import { OptionTableHF } from "../OptionTableHF";
import KK7766posts from "../KK7766posts";
import { ReactNode, use, useEffect, useMemo, useState } from "react";
import { TbBrowserMaximize, TbMinimize } from "react-icons/tb";
import { TbMaximizeOff, TbMaximize } from "react-icons/tb";
import { TbLayoutSidebarRightCollapse, TbLayoutSidebarRightExpand } from "react-icons/tb";
import { FaWindowMinimize } from "react-icons/fa6";
import { IoCloseOutline } from "react-icons/io5";
import { MdMinimize } from "react-icons/md";
import { Tab, useMinimizedTabsStore } from "../../stores/minimizedTabs";
import { useCalendarPanelStore } from "../../stores/calendarPanel";
import Expressions from "../Expressions";
import { Modal } from "../Modal";
import { LibraryEditor } from "../Editor";
import { BRSNLibrary } from "../BRSN_Library";
import { MultiIV } from "../Multi_IV";
import {Calendar} from "../Calendar";
import { IBKR } from "../ibkr/IBKR";
import { RealtimeIBKR } from "../ibkr/RealtimeIBKR";
import EventCandidates from "../EventCandidates";
import { RealTimeNotes } from "../RealTimeNotes";
import { Documentation } from "../Documentation";
import { RealtimeChart } from "../RealtimeChart";
import { Watchlist } from "../Watchlist";
import { ExtendedWatchlist } from "../ExtendedWatchlist";
import { SimulateWatchlist } from "../SimulateWatchlist";
import { TwitterNotifications } from "../TwitterNotifications";
import { KKCommentNoteEditor } from "../KKCommentNoteEditor";
import { IVPlot } from "../IVPlot";
import { Reactions } from "../Reactions";
import { SimulatedChart } from "../SimulatedChart";
import { TwitterRealtime } from "../TwitterRealtime";
import { ClearCross } from "../ClearCross";
import { Halts } from "../Halts";
import { ZhsBooking } from "../ZhsBooking";
import { IBKRChat } from "../ibkr_fast/IBKRChat";
import { ChartWindow } from "../ibkr_fast/ChartWindow";
import { PushoverFeedSection } from "../PushoverFeedSection";

export interface ComponentSettings {
  [key: string]: {
    title: string;
    size: { width: number; height: number };
  };
}

export const componentSettings: ComponentSettings = {
  options_definitions: {
    title: "Options Definitions",
    size: { width: 650, height: 800 },
  },
  opt_pricing_model: {
    title: "Opt. Pricing Model",
    size: { width: 800, height: 600 },
  },
  option_sovler: {
    title: "Option Solver",
    size: { width: 600, height: 800 },
  },
  equity_chart: {
    title: "Equity Chart",
    size: { width: 800, height: 600 },
  },
  kk7766: {
    title: "Comments",
    size: { width: 600, height: 600 },
  },
  kk7766posts: {
    title: "Posts",
    size: { width: 600, height: 600 },
  },
  timeline: {
    title: "Timeline",
    size: { width: 780, height: 800 },
  },
  news_search: {
    title: "News search",
    size: { width: 1000, height: 800 },
  },
  tweets_search: {
    title: "Tweets Search",
    size: { width: 800, height: 600 },
  },
  correlate: {
    title: "Correlate",
    size: { width: 1000, height: 800 },
  },
  reddit_search: {
    title: "Reddit Analysis",
    size: { width: 1100, height: 800 },
  },
  option_table_hf: {
    title: "Option Table (HF)",
    size: { width: 800, height: 800 },
  },
  expressions: {
    title: "Keyword Tracer",
    size: { width: 800, height: 800 },
  },

  brsn_library: {
    title: "BRSN Library",
    size: { width: 800, height: 800 },
  },

  add_brsn_observation: {
    title: "Add BRSN Observation",
    size: { width: 800, height: 800 },
  },

  multi_iv: {
    title: "Multi IV",
    size: { width: 800, height: 800 },
  },

  calendar: {
    title: "Calendar",
    size: { width: 800, height: 800 },
  },

  ibkr: {
    title: "IBKR",
    size: { width: 1000, height: 800 },
  },

  realtime_ibkr: {
    title: "Realtime IBKR",
    size: { width: 1100, height: 700 },
  },

  event_candidates: {
    title: "Event Candidates",
    size: { width: 800, height: 600 },
  },

  reactions: {
    title: "Reactions",
    size: { width: 900, height: 700 },
  },

  documentation: {
    title: "Documentation",
    size: { width: 900, height: 750 },
  },

  realtime_notes: {
    title: "Real Time Notes",
    size: { width: 800, height: 750 },
  },

  realtime_chart: { 
    title: "Real-time Chart",
    size: { width: 800, height: 800 },
  },

  watchlist: {
    title: "Watchlist",
    size: { width: 800, height: 800 },
  },

  extended_watchlist: {
    title: "Extended Watchlist",
    size: { width: 800, height: 800 },
  },

  simulate_watchlist: {
    title: "Simulate Watchlist",
    size: { width: 800, height: 800 },
  },

  simulated_chart: {
    title: "Simulated Chart",
    size: { width: 1100, height: 900 },
  },

  zhs_booking: {
    title: "ZHS Booking",
    size: { width: 900, height: 800 },
  },

  ibkr_chat: {
    title: "IBKR chat",
    size: { width: 480, height: 800 },
  },

  ibkr_chart: {
    title: "IBKR chart",
    size: { width: 900, height: 700 },
  },

  twitter_notifications: {
    title: "Twitter Notifications",
    size: { width: 400, height: 600 },
  },

  twitter_realtime: {
    title: "Twitter Real-time",
    size: { width: 800, height: 700 },
  },

  clearcross: {
    title: "ClearCross",
    size: { width: 820, height: 800 },
  },

  halts: {
    title: "Halts",
    size: { width: 1250, height: 800 },
  },

  kk_comment_note: {
    title: "KK Comment Note",
    size: { width: 700, height: 700 },
  },

  iv_ohlcv: {
    title: "IV OHLCV",
    size: { width: 900, height: 900 },
  },
};

export const components = {
  main_component: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <Main api={api} containerApi={containerApi} />;
  },

  options_definitions: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <OptionsDefinitions api={api} containerApi={containerApi} />;
  },

  opt_pricing_model: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <OptPricingModel api={api} containerApi={containerApi} />;
  },

  option_sovler: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <OptionSolver api={api} containerApi={containerApi} />;
  },

  equity_chart: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;
    const params = props.params as any;
    const initParams = params?.ticker ? { ticker: params.ticker, startDate: params.startDate, endDate: params.endDate, interval: params.interval } : undefined;

    return <EquityChart api={api} containerApi={containerApi} initParams={initParams} />;
  },

  kk7766: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <KK7766comments api={api} containerApi={containerApi} />;
  },

  kk7766posts: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <KK7766posts api={api} containerApi={containerApi} />;
  },

  timeline: (props: IDockviewPanelProps) => {
    return <PushoverFeedSection containerApi={props.containerApi} />;
  },

  news_search: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <NewsSearch api={api} containerApi={containerApi} />;
  },

  tweets_search: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <TweetsSearch api={api} containerApi={containerApi} />;
  },

  correlate: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    const params = props.params as any;

    return <Correlate api={api} containerApi={containerApi} initialQuery={params?.query} />;
  },

  reddit_search: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <RedditSearch panelApi={api} containerApi={containerApi} />;
  },

  option_table_hf: (props: IDockviewPanelProps) => {
    const api: DockviewPanelApi = props.api;
    const containerApi: DockviewApi = props.containerApi;

    return <OptionTableHF api={api} containerApi={containerApi} />;
  },

  expressions: (props: IDockviewPanelProps) => {
    return <Expressions {...props} />;
  },

  brsn_library: (props: IDockviewPanelProps) => {
    return <BRSNLibrary {...props} />
  },
 
  add_brsn_observation: (props: IDockviewPanelProps) => {
    return <LibraryEditor {...props} />
  },

  multi_iv: (props: IDockviewPanelProps) => {
    return <MultiIV {...props} />;
  },

  calendar: (props: IDockviewPanelProps) => {
    return <Calendar />;
  },

  ibkr: (props: IDockviewPanelProps) => {
    return <IBKR {...props} />;
  },

  realtime_ibkr: (props: IDockviewPanelProps) => {
    return <RealtimeIBKR {...props} />;
  },

  event_candidates: (props: IDockviewPanelProps) => {
    return <EventCandidates {...props} />;
  },

  reactions: (props: IDockviewPanelProps) => {
    return <Reactions api={props.api} containerApi={props.containerApi} />;
  },

  documentation: (props: IDockviewPanelProps) => {
    return <Documentation {...props} />;
  },

  realtime_notes: (_props: IDockviewPanelProps) => {
    return <RealTimeNotes />;
  },

  realtime_chart: (props: IDockviewPanelProps) => {
    return <RealtimeChart {...props} />;
  },

  watchlist: (props: IDockviewPanelProps) => {
    return <Watchlist {...props} />;
  },

  extended_watchlist: (props: IDockviewPanelProps) => {
    return <ExtendedWatchlist {...props} />;
  },

  simulate_watchlist: (props: IDockviewPanelProps) => {
    return <SimulateWatchlist {...props} />;
  },

  simulated_chart: (props: IDockviewPanelProps) => {
    return <SimulatedChart {...props} />;
  },

  zhs_booking: (props: IDockviewPanelProps) => {
    return <ZhsBooking {...props} />;
  },

  ibkr_chat: (props: IDockviewPanelProps) => {
    return <IBKRChat {...props} />;
  },

  ibkr_chart: (props: IDockviewPanelProps) => {
    return <ChartWindow {...props} />;
  },

  twitter_notifications: (props: IDockviewPanelProps) => {
    return <TwitterNotifications {...props} />;
  },

  kk_comment_note: (props: IDockviewPanelProps) => {
    return <KKCommentNoteEditor {...props} />;
  },

  iv_ohlcv: (props: IDockviewPanelProps) => {
    return <IVPlot {...props} />;
  },

  twitter_realtime: (props: IDockviewPanelProps) => {
    return <TwitterRealtime query={props.params?.query} />;
  },

  clearcross: (props: IDockviewPanelProps) => {
    return <ClearCross containerApi={props.containerApi} />;
  },

  halts: (props: IDockviewPanelProps) => {
    return <Halts containerApi={props.containerApi} />;
  },
};

export const tabComponents = {
  //   main_tab: (props: IDockviewPanelHeaderProps) => {
  //   const api: DockviewPanelApi  = props.api;
  //   const containerApi: DockviewApi  = props.containerApi;

  //   return <DockviewDefaultTab hideClose={true} {...props} />;
  // },

  main_tab: (props: IDockviewPanelHeaderProps) => {
    return <CustomTab {...props} />;
  },
};

function useNYCTime() {
  const [time, setTime] = useState(() =>
    new Date().toLocaleTimeString("en-US", {
      timeZone: "America/New_York",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
  );
  useEffect(() => {
    const id = setInterval(() => {
      setTime(
        new Date().toLocaleTimeString("en-US", {
          timeZone: "America/New_York",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
      );
    }, 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

export function CustomTab(props: IDockviewPanelHeaderProps) {
  const { api, containerApi } = props;
  const [title, setTitle] = useState<string>(api.title ?? api.id);
  const nycTime = useNYCTime();
  const calendarVisible = useCalendarPanelStore((s) => s.visible);
  const toggleCalendarPanel = useCalendarPanelStore((s) => s.toggle);


  useEffect(() => {
    const subscription = api.onDidTitleChange(() => {
      setTitle(api.title ?? api.id);
    });
    return () => {
      subscription.dispose();
    };
  }, [api]);

  function detachThisTab(e: React.MouseEvent) {
    e.stopPropagation();

    // get width / height from settings, split on the last underscore
    const splitter = props.api.id.lastIndexOf("_");
    const settingsId = props.api.id.substring(0, splitter);

    const { width, height } = componentSettings[settingsId]["size"];

    const panel = props.containerApi.getPanel(props.api.id);
    if (!panel) return;
    props.containerApi.addFloatingGroup(panel, {
      width: width,
      height: height,
      x: 50,
      y: 50,
    }); // optional: pass position (see below)
  }

  const onClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    api.close(); // disposes the panel
  };

  // Simple clone of the default tab layout + an extra action button
  return (
    <div className="dv-default-tab flex gap-1">
      <div className="dv-default-tab-content">
        {api.title ?? api.id}
        {api.id.startsWith("main") && (
          <span className="tab-nyc-time">{nycTime}</span>
        )}
      </div>
      {!api.id.startsWith("main") && (
        <button
          type="button"
          className="dv-default-tab-action"
          title="Detach (float)"
          aria-label="Detach"
          onClick={detachThisTab}
        >
          <TbBrowserMaximize size={14} />
        </button>
      )}

      {!api.id.startsWith("main") && (
        <button
          type="button"
          className="dv-default-tab-action"
          title="Close"
          aria-label="Close"
          onClick={onClose}
        >
          <IoCloseOutline size={14} />
        </button>
      )}

      {api.id.startsWith("main") && (
        <button
          type="button"
          className="dv-default-tab-action"
          title={calendarVisible ? "Hide calendar" : "Show calendar"}
          aria-label="Toggle calendar panel"
          onClick={(e) => {
            e.stopPropagation();
            toggleCalendarPanel();
          }}
        >
          {calendarVisible ? (
            <TbLayoutSidebarRightCollapse size={14} />
          ) : (
            <TbLayoutSidebarRightExpand size={14} />
          )}
        </button>
      )}
    </div>
  );
}

export function addFloatingPanel(
  api: DockviewApi,
  component: string,
  params: any
) {
  const { title, size } = componentSettings[component];

  api.addPanel({
    id: `${component}_${Date.now()}`,
    title: title,
    component: component,
    floating: { ...size, x: 50, y: 50 },
    params: params,
  });
}

export const RightControls = (props: IDockviewHeaderActionsProps) => {
  const { activePanel, api, containerApi, group, isGroupActive, panels } =
    props;

  const [hasMainPanel, setHasMainPanel] = useState<boolean>(false);

  useEffect(() => {
    const sub = containerApi.onDidActivePanelChange(() => {
      const myGroup = containerApi.groups.find((g) =>
        g.panels.find((p) => p.id === props.activePanel?.id)
      );

      if (!myGroup) return;

      setHasMainPanel(
        myGroup.panels.find((p) => p.id.startsWith("main_panel")) !== undefined
      );
    });

    return () => {
      sub.dispose();
    };
  }, [containerApi, props.activePanel]);

  const [isMaximized, setIsMaximized] = useState<boolean>(
    props.containerApi.hasMaximizedGroup()
  );

  const minimizedTabsStore = useMinimizedTabsStore();

  const onMaximizeClick = () => {
    // get viewport size
    if (!isMaximized) {
      const width = window.innerWidth;
      const height = window.innerHeight;

      props.containerApi.addFloatingGroup(props.group, {
        position: { top: 10, left: 10 },
      });

      // set the size of the panel to the viewport size
      props.api.setSize({ height: height - 20, width: width - 20 });
    } else {
      props.containerApi.addFloatingGroup(props.group, {
        position: { top: 50, left: 50 },
      });

      // get the width / height of the first panel in the group
      const myGroup = props.containerApi.groups.find((g) =>
        g.panels.find((p) => p.id === props.activePanel?.id)
      );

      if (!myGroup) return;

      const panelId = myGroup.activePanel?.id; 

      if (!panelId) return;

      const splitter = panelId.lastIndexOf("_");
      const settingsId = panelId.substring(0, splitter);
      
      const { width, height } = componentSettings[settingsId]["size"];

      // restore to original size
      props.api.setSize({ height: height, width: width });
    }

    setIsMaximized(!isMaximized);
  };

  const onMinimizeClick = () => {
    if (!props.activePanel) return;

    const myGroup = props.containerApi.groups.find((g) =>
      g.panels.find((p) => p.id === props.activePanel?.id)
    );

    if (!myGroup) return;

    // hide the panel
    myGroup.api.setVisible(false);

    // Capture only the stable string ID, not the group object itself.
    // The group object may be replaced by dockview internally over time,
    // making a direct reference stale. Look it up fresh at restore time.
    const groupId = myGroup.id;
    const capturedContainerApi = props.containerApi;

    const tabState: Tab = {
      name: groupId,
      panels: myGroup.panels.map((p) => p.title ?? p.id),
      setVisible: (visible: boolean) => {
        const freshGroup = capturedContainerApi.groups.find((g) => g.id === groupId);
        freshGroup?.api.setVisible(visible);
        freshGroup?.api.setActive();
      },
      close: () => {
        const freshGroup = capturedContainerApi.groups.find((g) => g.id === groupId);
        freshGroup?.api.close();
      },
    };

    minimizedTabsStore.addTab(tabState);
  };

  const onClose = () => {
    group.api.close();
  };

  return (
    <div
      className="group-control gap-2"
      style={{
        display: "flex",
        alignItems: "center",
        padding: "0px 8px",
        height: "100%",
        color: "var(--dv-activegroup-hiddenpanel-tab-color)",
      }}
    >
      <button
        type="button"
        className="dv-default-tab-action hover:bg-gray-300 rounded-sm"
        title="Minimize"
        aria-label="Minimize"
        onClick={onMinimizeClick}
      >
        <MdMinimize size={14} />
      </button>

      <button
        type="button"
        className="dv-default-tab-action hover:bg-gray-300 rounded-sm"
        title="Maximize / Restore"
        aria-label="Maximize / Restore"
        onClick={onMaximizeClick}
      >
        {isMaximized ? <TbMaximizeOff size={14} /> : <TbMaximize size={14} />}
      </button>

      {!hasMainPanel && (
        <button
          type="button"
          className="dv-default-tab-action hover:bg-gray-300 rounded-sm"
          title="Close"
          aria-label="Close"
          onClick={onClose}
        >
          <IoCloseOutline size={14} />
        </button>
      )}
    </div>
  );
};
